/**
 * Navigation icons, inline (ported pattern from legalcrm): ten glyphs is not worth an
 * icon dependency. All are `aria-hidden`: the label beside them is the accessible name.
 */
import type { NavIcon } from '@/routes/navigation';

const paths: Record<NavIcon, string> = {
  dashboard: 'M3 3h7v7H3zM14 3h7v4h-7zM14 10h7v11h-7zM3 13h7v8H3z',
  clients:
    'M3 20c0-3 2.5-5.5 5.5-5.5S14 17 14 20M8.5 11.5a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M16 20c0-2.5 1.4-4.4 3.5-5M17.5 11a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5',
  messages: 'M4 5h13v9H8l-4 3zM10 17h6l4 3v-9h-3',
  workouts: 'M5 9v6M8 7v10M16 7v10M19 9v6M8 12h8M2.5 12H5M19 12h2.5',
  diet: 'M4 11h16a8 8 0 0 1-16 0zM9 7c0-1.5 1-2.5 2-3M13 7c0-2 1.5-3 3-3.5M7 21h10',
  videos: 'M3 6h13v12H3zM16 10l5-3v10l-5-3',
  payments: 'M3 6h18v12H3zM3 10h18M7 15h4',
  announcements: 'M3 10v4a1 1 0 0 0 1 1h2l5 4V5L6 9H4a1 1 0 0 0-1 1ZM15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13',
  trainers: 'M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M5 21c0-3.9 3.1-7 7-7s7 3.1 7 7M15.5 14.5 12 21l-3.5-6.5',
  import: 'M12 3v12M7 10l5 5 5-5M4 17v3h16v-3',
  settings:
    'M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M19.4 13a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6h.09A1.65 1.65 0 0 0 10.6 3.09V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z',
};

export function NavGlyph({ name, className }: { name: NavIcon; className?: string }) {
  return (
    <svg
      className={className ?? 'h-[18px] w-[18px] shrink-0'}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[name]} />
    </svg>
  );
}
